import { render, staticRenderFns } from "./Carousel3dCoverflowEffect.vue?vue&type=template&id=24ea7b38&scoped=true&"
import script from "./Carousel3dCoverflowEffect.vue?vue&type=script&lang=js&"
export * from "./Carousel3dCoverflowEffect.vue?vue&type=script&lang=js&"
import style0 from "./Carousel3dCoverflowEffect.vue?vue&type=style&index=0&id=24ea7b38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ea7b38",
  null
  
)

export default component.exports